import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { UNATHORIZED } from "../common/constants/routes.constants";
import { useUserStore } from "../store/useUserStore";
import { hasPanelAccess } from "../api/api";

const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { userInfo } = useUserStore();

  if (!hasPanelAccess(userInfo)) {
    return <Navigate to={UNATHORIZED} replace />;
  }

  return children;
};

export default ProtectedRoute;
